import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { store } from '../../store/store';

const ReduxLanguageDetector = {
  name: 'redux',
  type: 'languageDetector',
  async: false,
  detect: () => {
    try {
      const state = store?.getState?.();
      const fromRedux =
        state?.auth?.currentUser?.language ||
        state?.customization?.language;

      const fromStorage = (() => {
        try { return localStorage.getItem('i18nextLng'); } catch { return null; }
      })();

      const fromNavigator = typeof navigator !== 'undefined'
        ? (navigator.language || (navigator.languages && navigator.languages[0]))
        : null;

      return fromRedux || fromStorage || fromNavigator || 'pt-BR';
    } catch {
      return 'pt-BR';
    }
  },
  cacheUserLanguage: (lng) => {
    try { localStorage.setItem('i18nextLng', lng); } catch { }
  }
};


function resolveLang(code) {
  if (!code) return 'pt-BR';
  const raw = Array.isArray(code) ? code[0] : code;
  const lower = raw.toLowerCase();

  if (lower.startsWith('pt')) return 'pt-BR';
  if (lower.startsWith('en')) return 'en';
  if (lower.startsWith('es')) return 'es';
  return 'pt-BR';
}

i18n
  .use(Backend)
  .use(ReduxLanguageDetector)
  .use(LanguageDetector)
  .use(initReactI18next)

  .init({
    supportedLngs: ['pt-BR', 'pt', 'en', 'es'],
    fallbackLng: 'pt-BR',

    ns: ['translation'],
    defaultNS: 'translation',

    backend: {
      loadPath: (lng, ns) => {
        const langFolder = resolveLang(lng);
        return `${process.env.PUBLIC_URL || ''}/locales/${langFolder}/${ns}.json`;
      },
    },

    detection: {
      order: ['navigator', 'querystring', 'localStorage'], // Prioridade de detecção
      caches: ['localStorage'], // Cachear a preferência do idioma no localStorage
    },
  });

let lastLng = i18n.language;
store.subscribe(() => {
  const state = store.getState?.();
  const nextLng =
    state?.auth?.currentUser?.language ||
    state?.customization?.language;

  if (nextLng && nextLng !== lastLng) {
    lastLng = nextLng;
    i18n.changeLanguage(nextLng);
  }
});
export default i18n;